import React, { useRef, useState } from 'react'
import styled from 'styled-components'
import { colors } from '../../Assets/styles/colors'
import { Rating } from '@mui/material'
import { useTranslate } from '@tolgee/react';

const RatingModal = ({ sendRating, setShowRatingCard, showRatingCard }) => {
    const { t } = useTranslate();
    const [ratingValue, setRatingValue] = useState(0);
    const ref = useRef();

    const handleRating = (rating) => {
        sendRating(rating);
    }

    const handleClose = () => {
        setShowRatingCard(false);
    }

    return (
        <FullScreenItem>
            <RatingCard ref={ref}>
                <CloseButtonWrapper onClick={handleClose}>
                    <span style={{ fontSize: '20px', fontWeight: 'bold', color: 'white' }}>✕</span>
                </CloseButtonWrapper>
                
                <h1>{t('chat.rating_modal_message')} </h1>
                <Rating
                    name="simple-controlled"
                    value={ratingValue}
                    size='large'
                    className='rating-custom'
                    onChange={(event, newValue) => {
                        handleRating(newValue)
                    }}
                />
                
                <SecondaryAction onClick={handleClose}>
                    {t('general.remind_me_later', 'Remind me later')}
                </SecondaryAction>
            </RatingCard>
        </FullScreenItem>
    )
}

export default RatingModal

const FullScreenItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  left: 0;
  top: 0;
  z-index: 9999;
`

const RatingCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  min-height: 200px;
  max-width: 400px;
  width: 100%;
  background: ${colors.receivedMessageBg};
  border-radius: 12px;
  padding: 30px;
  align-items: center;
  position: relative; /* Important for the close button anchor */
  
  h1 {
    font-size: 20px;
    line-height: 24px;
    font-weight: 600;
    text-align: center;
    color: ${colors.white};
  }
  .rating-custom {
    span {
      font-size: 40px;
      color: ${colors.purple};
    }
  }
`

const CloseButtonWrapper = styled.div`
  position: absolute;
  top: 7px;
  right: 7px;
  cursor: pointer;
  opacity: 0.5;
  width: 20px; 
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    opacity: 1;
  }
`;

const SecondaryAction = styled.div`
  cursor: pointer;
  color: ${colors.white};
  font-size: 14px;
  text-decoration: underline;
  opacity: 0.7;
  &:hover {
    opacity: 1;
  }
`;